import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAbLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 152,
	height: 30,
	viewBox: "0 0 152 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.4019 1.68379C14.2818 1.35928 14.5197 1.0138 14.8657 1.01027L27.4145 0.882052C27.45 0.880233 27.4856 0.87872 27.5213 0.877516C27.6538 0.87304 27.7852 0.872889 27.9155 0.876932L28.0207 0.875857L28.0215 0.88115C31.5421 1.05242 34.2201 4.28659 34.3444 7.96442C34.4459 10.9687 32.6743 13.5919 30.1025 14.6599C33.1357 15.137 35.5298 18.0181 35.6502 21.5808C35.7846 25.5589 33.0313 28.3581 29.5031 28.4772C29.4553 28.4788 29.4077 28.48 29.3602 28.4806C29.3466 28.4887 29.3309 28.4941 29.3134 28.4959L24.887 28.9367C24.6606 28.9592 24.4475 28.8261 24.3686 28.6127L14.4019 1.68379ZM12.0822 2.00739C11.9242 1.57742 11.3194 1.56846 11.1488 1.99357L0.537649 28.4372C0.363259 28.8718 0.828438 29.2861 1.24007 29.0629L10.6659 23.9506C10.8101 23.8724 10.9835 23.8699 11.1299 23.9439L21.0617 28.9668C21.4667 29.1717 21.9132 28.7743 21.7567 28.3482L12.0822 2.00739Z",
			fill: "url(#paint0_linear_496_5069)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.1633 19.9493H43.6553L49.3933 6.64929H51.7303L57.4873 19.9493H54.9603L53.7063 17.0423H47.4173L46.1633 19.9493ZM50.5523 9.51829L48.2343 14.9713H52.8893L50.5903 9.51829H50.5523Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.294 19.9493H59.09V6.15529H61.294V19.9493Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.6175 19.3603V18.3913C70.9335 19.1703 69.9835 19.7213 68.3685 19.7213C65.7275 19.7213 63.5425 17.7453 63.5425 14.8763C63.5425 12.0073 65.7275 10.0313 68.3685 10.0313C70.2305 10.0313 71.1615 10.7913 71.8075 11.6273V10.2403H73.8215V19.1513C73.8215 22.4953 71.5035 24.0533 68.7105 24.0533C66.1645 24.0533 64.7205 22.9133 64.0745 21.6403L65.8225 20.6333C66.2975 21.3553 67.1525 22.0393 68.6725 22.0393C70.3065 22.0393 71.5985 21.1463 71.6175 19.3603ZM68.6725 17.6123C70.3635 17.6123 71.6175 16.5103 71.6175 14.8763C71.6175 13.2613 70.3635 12.1403 68.6725 12.1403C66.9815 12.1403 65.7465 13.2613 65.7465 14.8763C65.7465 16.5103 66.9815 17.6123 68.6725 17.6123Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.104 15.0853C76.104 12.2163 78.327 10.0313 81.253 10.0313C84.16 10.0313 86.402 12.2163 86.402 15.0853C86.402 17.9543 84.16 20.1583 81.253 20.1583C78.327 20.1583 76.104 17.9543 76.104 15.0853ZM81.253 18.0493C82.925 18.0493 84.179 16.7193 84.179 15.0853C84.179 13.4703 82.925 12.1403 81.253 12.1403C79.543 12.1403 78.327 13.4703 78.327 15.0853C78.327 16.7193 79.543 18.0493 81.253 18.0493Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.2831 19.9493H88.7231V6.64929H92.9981C95.1071 6.64929 97.1971 7.71329 97.1971 10.2783C97.1971 11.8173 96.3421 12.6533 95.4871 13.1093C96.4181 13.5273 97.6721 14.4393 97.6721 16.3583C97.6721 18.9423 95.6771 19.9493 93.2831 19.9493ZM90.9651 8.64429V12.2353H92.8651C94.1381 12.2353 94.9551 11.6273 94.9551 10.4493C94.9551 9.25229 94.1571 8.64429 92.8841 8.64429H90.9651ZM90.9651 14.2303V17.9543H93.1691C94.6701 17.9543 95.4301 17.3273 95.4301 16.1683C95.4301 14.9523 94.5181 14.2303 93.0551 14.2303H90.9651Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M104.108 20.1583C102.056 20.1583 99.7949 18.8853 99.7949 15.7313V10.2403H101.999V15.4463C101.999 17.3083 102.835 18.0683 104.108 18.0683C105.381 18.0683 106.198 17.3083 106.198 15.4463V10.2403H108.402V15.7313C108.402 18.8853 106.16 20.1583 104.108 20.1583Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.074 7.29529C111.074 6.55429 111.644 5.94629 112.423 5.94629C113.164 5.94629 113.772 6.55429 113.772 7.29529C113.772 8.03629 113.164 8.64429 112.423 8.64429C111.644 8.64429 111.074 8.03629 111.074 7.29529ZM113.525 19.9493H111.321V10.2403H113.525V19.9493Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118.795 19.9493H116.591V6.15529H118.795V19.9493Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.341 6.15529V19.9493H129.346V18.5433C128.681 19.3983 127.731 20.1583 125.888 20.1583C123.247 20.1583 121.043 17.9733 121.043 15.0853C121.043 12.2163 123.247 10.0313 125.888 10.0313C127.503 10.0313 128.453 10.6963 129.137 11.4753V6.15529H131.341ZM126.192 12.1403C124.501 12.1403 123.266 13.4703 123.266 15.0853C123.266 16.7193 124.501 18.0493 126.192 18.0493C127.864 18.0493 129.118 16.7193 129.118 15.0853C129.118 13.4703 127.864 12.1403 126.192 12.1403Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M143.428 14.7623C143.428 15.1613 143.352 15.6933 143.276 15.9403H135.923C136.265 17.3083 137.424 18.1443 138.811 18.1443C139.875 18.1443 140.502 17.8973 141.414 17.1753L142.706 18.6383C141.547 19.6643 140.293 20.1583 138.754 20.1583C135.828 20.1583 133.605 17.9733 133.605 15.0853C133.605 12.2163 135.828 10.0313 138.754 10.0313C141.737 10.0313 143.428 12.1593 143.428 14.7623ZM135.923 14.1923L141.281 14.1733C141.129 12.9383 140.312 11.9693 138.754 11.9693C137.386 11.9693 136.284 12.8623 135.923 14.1923Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M147.889 19.9493H145.685V10.2403H147.699V12.0833C148.136 11.0383 149.01 10.0313 151.347 10.0313L151.328 12.3873C148.725 12.3873 147.889 13.7553 147.889 15.4463V19.9493Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_496_5069",
			x1: -14.5664,
			y1: -37.7361,
			x2: 52.4175,
			y2: -25.6454,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .343052,
				stopColor: "#1570EF"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#004CE0"
			})]
		}) })
	]
});
export default SvgAbLogo;
